export var SkeletonLoaderStringsForDocs = function () {
    return {
        /** String to display in the label */
        'skeletonLoader.ariaLabel': 'Loading...',
    };
};
export var SkeletonLoaderStrings = SkeletonLoaderStringsForDocs();
